/* eslint-disable react/jsx-no-useless-fragment */
import { Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect } from 'react';
import { useDropzone } from 'react-dropzone';
import { MdFolder } from 'react-icons/md';

import api, { authHeader } from '../../../../services/API/apiConfig';
import {
  DropzoneStyled,
  IconContainerStyled,
  RootStyled,
} from './FileDropZone.styles';

export function Dropzone(props) {
  const { route, isFacade, setUploading, setPost, setImg, setFile } = props;

  const { acceptedFiles, isDragActive, getRootProps, getInputProps } =
    useDropzone({
      accept: {
        'application/pdf': ['.pdf'],
        'text/csv': ['.csv'],
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [
          '.xlsx',
        ],
        'text/plain': ['.txt'],
        'application/msword': ['.doc', '.docx'],
        'image/png': ['.png'],
        'image/jpeg': ['.jpeg', '.jpg'],
        'image/vnd.dwg': ['.dwg'],
      },
    });

  const sendFiles = useCallback(
    (selectedFile) => {
      if (acceptedFiles.length) {
        setUploading(true);
        api
          .post(route, selectedFile, {
            headers: {
              ...authHeader(),
              'Content-Type': 'multipart/form-data',
            },
          })
          .then(() => {
            setPost(true);
            setUploading(false);
          });
      }
    },
    [acceptedFiles, route, setUploading, setPost]
  );

  useEffect(() => {
    if (!isFacade) {
      setFile(acceptedFiles);
      const fd = new FormData();
      if (acceptedFiles.length) {
        for (let i = 0; i < acceptedFiles.length; i += 1) {
          fd.append('files[]', acceptedFiles[i]);
        }
      }
      sendFiles(fd);
    } else if (acceptedFiles && acceptedFiles.length === 1) {
      setUploading(true);
      setImg(window.URL.createObjectURL(acceptedFiles[0]));
      setFile(acceptedFiles[0]);
      setTimeout(() => {
        setUploading(false);
      }, 300);
    }
  }, [isFacade, sendFiles, setImg, setUploading]);

  return (
    <>
      <RootStyled>
        <IconContainerStyled {...getRootProps()}>
          <input {...getInputProps()} />
          <MdFolder />
        </IconContainerStyled>
        <DropzoneStyled {...getRootProps()}>
          <input {...getInputProps()} />
          {isDragActive ? (
            <Typography>Solte os arquivos</Typography>
          ) : (
            <Typography>Arraste os arquivos</Typography>
          )}
        </DropzoneStyled>
      </RootStyled>
    </>
  );
}

Dropzone.propTypes = {
  route: PropTypes.string.isRequired,
  isFacade: PropTypes.bool,
  setImg: PropTypes.func,
  setUploading: PropTypes.func,
  setPost: PropTypes.func,
};

Dropzone.defaultProps = {
  isFacade: false,
  setUploading: () => {},
  setPost: () => {},
  setImg: () => {},
};
